//AboutUs.View.js
define(
   'ContactUs.View'
,   [
      'contact_us.tpl'

   ,  'Backbone'
   ,  'jQuery'
   ,  'Backbone.FormView'
   ,  'ContactUs.Model'
   ,  'Profile.Model'
   ,  'underscore'
   ]
,   function (
      contact_us_tpl

   ,  Backbone
   ,  jQuery
   ,  BackboneFormView
   ,  ContactUsModel
   ,  ProfileModel
   ,  _
   )
{
   'use strict';

   //@class Address.List.View List profile's addresses @extend Backbone.View
   return Backbone.View.extend({

      template: contact_us_tpl

	,  title: _('Contact Us').translate()
	
	,	events:
		{
			'click [data-action="createLead"]': 'createLead'
		}
	
	,	initialize : function()
		{	
			this.model = new ContactUsModel();
			this.model.on('save', _.bind(this.showSuccess, this));
			BackboneFormView.add(this);
		}	
	
	,	getBreadcrumbPages: function()
		{
			return {
				href:'/contact-us'
			,	text:'CONTACT US'
			};
		}

	,	showSuccess: function() {
			//$('#custom-error-message').addClass("alert-success");
			//$('#custom-error-message').html("Your application is successfully sent.");
		}	

	,	bindings: {
			'[name="email"]': 'email',
			'[name="firstName"]': 'firstName',
			'[name="lastName"]': 'lastName',
			'[name="message"]': 'message'
		}
	
	// ,	createLead: function()
	// 	{
	// 		$('#custom-error-message').html("");
	// 		$('#custom-error-message').removeClass();
	// 		var firstName = $("#firstName").val();
	// 		var lastName = $('#lastName').val();
	// 		var company = $('#company').val();
	// 		var address1 = $('#address1').val();
	// 		var address2 = $('#address2').val();
	// 		var city = $('#city').val();
	// 		var state = $('#state').val();
	// 		var zipcode = $('#zipcode').val();
	// 		var phone = $('#phone').val();
	// 		var email = $('#email').val();
	// 		var message = $('#message').val();
	// 		var existingCustomer = $('#existingCustomer').val();
			
	// 		if(firstName != null && firstName != '' && lastName != null && lastName != '' && email != null && email != '')
	// 		{				
	// 		 var SearchList = Backbone.Collection.extend({
	// 		 url: '/app/site/hosting/scriptlet.nl?script=437&deploy=1'
	// 		});
				
	// 		var output = new SearchList();
			
	// 		output.fetch({
	// 		async:false 
	// 	  , data:{ firstName: firstName,lastName: lastName,company: company,address1: address1,address2: address2,city: city,state: state,zipcode: zipcode,phone: phone,email: email,message: message,existingCustomer:existingCustomer}
	// 	  , success: function(response) {
	// 		  if(response != null && response != '')
	// 		  {
	// 			  var jsonResp = response.toJSON();
	// 			  var responseObj = jsonResp[0];				  
	// 			  if(responseObj.hasOwnProperty('id'))
	// 			  {
	// 				  $('#custom-error-message').addClass("alert-success");
	// 				$('#custom-error-message').html("Successfully updated your details."); 
	// 				location.href = SC.SESSION.touchpoints.home;
	// 			  }
				
	// 			else if(responseObj.hasOwnProperty('error'))
	// 			{
	// 				$('#custom-error-message').addClass("alert-danger");
	// 				$('#custom-error-message').html("Something went wrong! Please try again later."); 
	// 			}
	// 		  }				  			  
	// 		 }
	// 		});
	// 		}
	// 		else{
	// 			$('#custom-error-message').addClass("alert-danger");
	// 			$('#custom-error-message').html("Please fill all the mandatory details");
	// 		} 	
	// 	}

	,	createLead: function(e, model, props)
		{
			
			/*** Contact Us New Customization Service controller ***/
			e.preventDefault();
			var contactFields={};
			
			var profile = ProfileModel.getInstance();
			var loggedIn = profile.get('isLoggedIn') === 'T';
			
			$('.contact-us-form-input').each(function () {
				if ($(this).is('[type="checkbox"]'))
					contactFields[$(this).attr('id')] = $(this).is(':checked') ? 'T' : 'F';
				else
					contactFields[$(this).attr('id')] = $(this).val();
			});

			contactFields.existingCustomer = $('[name="existingCustomer"]').is(':checked') ? 'Yes' : 'No';

			var customerName ='';// (loggedIn) ? (((profile.get("firstname") + " User") || (profile.get("companyname") + " User"))) : "Guest User";
			if(loggedIn){
				if(profile.get('firstname')!=null && profile.get('firstname')!=''){
					customerName = profile.get('firstname') + ' User';
				}
				else{
					customerName = profile.get('companyname') + ' User';
				}
			}
			else{
				customerName = 'Guest User';
			}

			var customerPhone = (contactFields.phone != null && contactFields.phone != '') ? contactFields.phone : '';
			var customerComp = (contactFields.company != null && contactFields.company != '') ? contactFields.company : '';
			contactFields.subject = 'Custom Requirements from the Contact Us Page by '+customerName;
			contactFields.body =
				"<div>" +
				"<p><b>Customer Name :</b> " +
				customerName +
				"</p>" +
				"<p><b>First Name :</b> " +
				contactFields.firstName +
				"</p>" +
				"<p><b>Last Name :</b> " +
				contactFields.lastName +
				"</p>" +
				"<p><b>Email :</b> " +
				contactFields["email"] +
				"</p>" +
				"<p><b>Phone :</b> " +
				customerPhone +
				"</p>" +
				"<p><b>Company :</b> " +
				customerComp +
				"</p>" +
				"<p><b>Address 1 :</b> " +
				contactFields.address1 +
				"</p>" +
				"<p><b>Address 2 :</b> " +
				contactFields.address2 +
				"</p>" +
				"<p><b>City :</b> " +
				contactFields.city +
				"</p>" +
				"<p><b>State :</b> " +
				contactFields.state +
				"</p>" +
				"<p><b>ZIP Code :</b> " +
				contactFields.zipcode +
				"</p>" +
				"<p><b>Existing Customer :</b> " +
				contactFields.existingCustomer +
				"</p>" +
				"<p><b>Comments : </b><br>" +
				contactFields.message.replace(/\n/g, '<br />') +
				"</p>" +
				"<br>" +
				"<p>" +
				"Regards," +
				"</p>" +
				"</div>";
			this.model.set('contactFields',contactFields);
			var save_form = this.saveForm(e,model,props);
			if(save_form){
				save_form.done(function(res){
					document.getElementById('contactus-form').reset();
					if(res.id){
						$('#custom-error-message').addClass("alert-success");
						$('#custom-error-message').html("Your application is successfully sent.");
						
					}
					else{
						$('#custom-error-message').addClass("alert-danger");
						$('#custom-error-message').html("Something went wrong! application could not sent.");
					}
				});
			}
			/*** Contact Us New Customization Service controller ***/
					
		}

   ,   getContext: function ()
      {
         
		return {
            
         };
      }
   });
});
